<nav class="extent" [class.vertical]="vertical">
    <button *ngFor="let extentConfig of extentConfigs"
            class="btn btn-grouped btn-white {{extentConfig.qualifiedIcon}} {{extentConfig.qualifiedIconColor}}"
            [class.icon-ui-flush]="!showLabels"
            [class.isSvg]="extentConfig.isSVG"
            [title]="extentConfig.toolTip"
            (click)="executeExtentChange(extentConfig)">
        <svg *ngIf="extentConfig.isSVG"
             xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 30 30"
             class="svg-icon"
             [ngClass]="extentConfig.qualifiedSVGColor"
             [class.icon-ui-flush]="!showLabels">
            <path d="" [attr.d]="extentConfig.icon" />
        </svg>
        {{ showLabels ? extentConfig.label : '' }}
    </button>
</nav>
